export const CHUNK_RELOAD_SESSION_KEY = 'digipalz_chunk_reload_attempted'

const DYNAMIC_IMPORT_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'Unable to preload CSS for /assets/',
  "Unexpected token '<'"
]

function extractErrorMessage(errorLike) {
  return (
    errorLike?.message || errorLike?.reason?.message || String(errorLike || '')
  )
}

export function hasChunkLoadError(errorLike) {
  const message = extractErrorMessage(errorLike)

  return DYNAMIC_IMPORT_ERROR_PATTERNS.some((pattern) =>
    message.includes(pattern)
  )
}

export function reloadOnceForChunkMismatch(
  errorLike,
  storage = sessionStorage,
  reloadFn = () => window.location.reload()
) {
  if (typeof window === 'undefined') return false

  const alreadyReloaded = storage.getItem(CHUNK_RELOAD_SESSION_KEY) === '1'
  if (alreadyReloaded) return false
  if (!hasChunkLoadError(errorLike)) return false

  storage.setItem(CHUNK_RELOAD_SESSION_KEY, '1')
  reloadFn()
  return true
}

